export default __webpack_public_path__ + "img/aabb101fd94fca80b7dfb4782ef78102.png";